export const SMTP_CREDENTIALS_TEST_TIMEOUT_MS = 60_000;
